import { useState } from 'react';
import { areEquivalent } from 'Util';

export const useUpdatableObject = (
  update = () => {},
  create = () => {},
  fieldsToIncludeInUpdate = [],
  primaryKeyField = 'id',
) => {
  const [originalObject, setOriginalObject] = useState({});
  const [currentObject, setCurrentObject] = useState({});
  const [hasBeenUpdated, setHasBeenUpdated] = useState(false);
  const [updatedFields, setUpdatedFields] = useState({});

  const reset = (resetObject) => {
    resetObject && setCurrentObject(resetObject);
    resetObject && setOriginalObject({ ...resetObject });
    setUpdatedFields(
      !resetObject || resetObject[primaryKeyField] ? {} : { ...resetObject },
    );
    setHasBeenUpdated(!resetObject || !resetObject[primaryKeyField]);
  };

  const updateField = (fieldName, newValue) => {
    const oldValue = originalObject[fieldName];
    let newObject = { ...currentObject };
    newObject[fieldName] = newValue;
    setCurrentObject(newObject);

    let newUpdatedFields = { ...updatedFields };
    newUpdatedFields &&
      newUpdatedFields[fieldName] &&
      delete newUpdatedFields[fieldName];
    if (
      (!oldValue && newValue) ||
      (oldValue && !newValue) ||
      !areEquivalent(oldValue, newValue)
    ) {
      newUpdatedFields[fieldName] = newValue;
    }
    setUpdatedFields(newUpdatedFields);
    setHasBeenUpdated(Object.keys(newUpdatedFields).length > 0);
  };

  const updateFields = (fieldsToUpdate) => {
    let newObject = { ...currentObject };
    let newUpdatedFields = { ...updatedFields };
    Object.entries(fieldsToUpdate).forEach(([key, newValue]) => {
      newUpdatedFields[key] && delete newUpdatedFields[key];
      let oldValue = originalObject[key];
      newObject[key] = newValue;
      if (
        (!oldValue && newValue) ||
        (oldValue && !newValue) ||
        !areEquivalent(oldValue, newValue)
      ) {
        newUpdatedFields[key] = newValue;
      }
    });

    setCurrentObject(newObject);
    setUpdatedFields(newUpdatedFields);
    setHasBeenUpdated(Object.keys(newUpdatedFields).length > 0);
  };

  const doSave = () => {
    let existingFields = fieldsToIncludeInUpdate.reduce((obj, fieldName) => {
      obj[fieldName] = currentObject[fieldName];
      return obj;
    }, {});

    setHasBeenUpdated(false);
    if (originalObject[primaryKeyField]) {
      return update({
        [primaryKeyField]: currentObject[primaryKeyField],
        ...existingFields,
        ...updatedFields,
      });
    } else {
      return create(currentObject);
    }
  };

  return {
    currentObject,
    hasBeenUpdated,
    reset,
    updateField,
    updateFields,
    updatedFields,
    originalObject,
    doSave,
  };
};
